import type { LoadedSchema } from '@cli-types/core-engine/schema-reader.js'

export function collectSchemaRelationshipTargets(loaded: LoadedSchema): string[] {
  const targets = new Set<string>()

  function walkFields(fields: unknown): void {
    if (!Array.isArray(fields)) return

    for (const field of fields) {
      if (!field || typeof field !== 'object') {
        continue
      }

      const fieldRecord = field as Record<string, unknown>
      const relationship =
        typeof fieldRecord.relationship === 'string' ? fieldRecord.relationship : undefined
      if (relationship) {
        targets.add(relationship)
      }

      walkFields(fieldRecord.fields)

      if (Array.isArray(fieldRecord.tabs)) {
        for (const tab of fieldRecord.tabs) {
          if (!tab || typeof tab !== 'object') {
            continue
          }
          walkFields((tab as Record<string, unknown>).fields)
        }
      }
    }
  }

  if (loaded.type === 'form') {
    walkFields(loaded.schema.fields)
    if (Array.isArray(loaded.schema.steps)) {
      for (const step of loaded.schema.steps) {
        walkFields(step.fields)
      }
    }
  } else {
    walkFields(loaded.schema.fields)
  }

  return Array.from(targets)
}
